



































































































import { Component, Vue } from 'vue-property-decorator'
import OrderMallList from '@/views/industryMall/order/OrderMallList.vue'
import { getStoreOrderCount, getFollowStoreList } from '@/api/industryMall'
import { Action, Getter } from 'vuex-class'
import { LoginReturnDataDto } from '@/utils/h5ToApp'
import companyApprove from './workbench/companyApprove.vue'
import withePay from './workbench/withePay.vue'
import companyServe from './workbench/companyServe.vue'
import residentNavigator from '@/views/industryMall/order/workbench/residentNavigator.vue'
import topServe from './workbench/topServe.vue'
import { GetCompanyDtl } from '@/api/company'
import { getWhiteSign } from '@/api/iousServices'
import { isTourist, goToLogin } from '@/utils/util'
import dayjs from 'dayjs'
interface OrderCountListDto {
  orderCount?: number
  orderStatus?: string
}
@Component({
  name: 'ApplicationList',
  components: {
    OrderMallList,
    companyApprove,
    withePay,
    companyServe,
    topServe,
    residentNavigator
  }
})
export default class ApplicationList extends Vue {
  @Getter partnerCompanyId!: string
  @Getter companyId!: string
  @Getter info!: LoginReturnDataDto
  @Action setRouterAlive
  isTourist = isTourist
  goToLogin = goToLogin

  private isIdentification = 1

  // 待发货
  order1: OrderCountListDto = {}
  // 待收货
  order2: OrderCountListDto = {}
  // 已完成
  order3: OrderCountListDto = {}
  // 退货售后
  order4: OrderCountListDto = {}
  // 待支付
  order5: OrderCountListDto = {}

  whiteSignTime = ''
  endSignTime = ''

  show = true
  payStatus:string|number = 0 // 付款状态
  orderStatus:string|number = 0 // 订单状态

  total = 0 // 关注店铺总数
  // 是否有合作方
  get isPartnerAccount() {
    return this.info.currentVersionCode !== 'system'
  }

  created() {
    console.log('shopMallOrder=========created')
    this.getStoreOrderCount()
    this.getCompanyDtl()
    // this.getSign()
    this.$nextTick(() => {
      this.getSign()
    })
  }

  mounted() {
    this.refreshPage()  
    this.getFollowStoreList()
  }

  handleClick () {
    if (isTourist()) {
      goToLogin()
      return false
    }
  }

    /**
   * @description 获取关注店铺列表
   */
  getFollowStoreList() {
    const params = {
      partnerCompanyId: this.partnerCompanyId,
      companyId: this.companyId,
      pageIndex: 1,
      pageSize: 10
    }
    getFollowStoreList(params)
      .then((res) => {
        this.total = res.data.totalRecords
      })
  }
  /**
   * 原生页面返回无感刷新方式
   */
  refreshPage() {
    this.$bridge.registerHandler(
      'refreshPage',
      (data: string, responseCallback) => {
        console.log('重新刷新了')
        // window.location.reload()
        // 【正式环境】关于IOS版本直通装APP订单选择问题20240115
        // 注意：当前页面进入原生页面，返回重新调用了refreshPage，当前页面做特殊处理
        if (this.$route.name === 'SubmitMallOrder') {
          return false
        } else {
          this.setRouterAlive(false)
          this.$nextTick(() => {
            this.setRouterAlive(true)
          })
        }
      }
    )
  }

  /**
   * 获取公司是否认证
   * isIdentification	是否认证1:认证，0未认证
   */
  getCompanyDtl() {
    GetCompanyDtl({}).then((res) => {
      this.isIdentification = res.data.isIdentification
    })
  }

  toOrderList(type?: string|number, name = '全部订单') {
    console.log('全部订单', 11111)
    if (type === 99) {
      this.payStatus = type
      this.orderStatus = ''
    } else{
      this.orderStatus = type
      this.payStatus = ''
    }
    if (isTourist()) {
      goToLogin()
      return false
    }
    this.$router.push({
      path: '/orderMall',
      query: {
        orderType: String(this.orderStatus),
        payType: String(this.payStatus),
        orderName: name
      }
    })
  }
  /* 1.6 获取不同状态的订货数量(getStoreOrderCount) */
  getStoreOrderCount() {
    const data = {
      partnerCompanyId: this.partnerCompanyId,
      companyId: this.companyId
    }
    if (!this.isPartnerAccount) {
      return false
    }
    getStoreOrderCount(data).then((res) => {
      this.order1 = res.data.find((item) => item.orderStatus === '0')
      this.order2 = res.data.find((item) => item.orderStatus === '10')
      this.order3 = res.data.find((item) => item.orderStatus === '30')
      this.order4 = res.data.find((item) => item.orderStatus === '-2')
      this.order5 = res.data.find((item) => item.orderStatus === '99')
    })
  }
  // 获取授权书记录
  getSign() {
    console.log('执行了')
    // 避免接口取消
    getWhiteSign({ refresh: '1' }).then((res) => {
      const { code, data } = res
      if (code === '000000' && data) {
        let firstSignTime = data.whiteSignTime
        firstSignTime = dayjs(firstSignTime).format('YYYY-MM-DD')
        this.endSignTime = dayjs(firstSignTime)
          .add(360, 'day')
          .format('YYYY-MM-DD')
        this.whiteSignTime = dayjs().format('YYYY-MM-DD')
        console.log('首次签署日期=======', firstSignTime)
        console.log('再次签署日期=======', this.endSignTime)
        if (this.whiteSignTime < this.endSignTime)
          window.localStorage.setItem('isSign', '1')
      }
    })
  }

  approveConfirm () {

  }
  goLikeStore() {
    if (isTourist()) {
      goToLogin()
      return false
    }
    this.$router.push({
      path:'/storeCollectList'
    })
  }
}
